var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIncrementValue = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M8.584 11.137v3.113h-.74v-3.113zm.111-.907a.4.4 0 0 1-.039.181.5.5 0 0 1-.105.15.5.5 0 0 1-.15.102.48.48 0 0 1-.369 0 .5.5 0 0 1-.249-.252.5.5 0 0 1 0-.37.464.464 0 0 1 .618-.252.48.48 0 0 1 .294.44Zm.8 1.944c0-.207.168-.375.375-.375h.75v-.75a.375.375 0 0 1 .75 0v.75h.75a.375.375 0 0 1 0 .75h-.75v.75a.375.375 0 0 1-.75 0v-.75h-.75a.375.375 0 0 1-.375-.375m3.75 0c0-.207.168-.375.375-.375h.75v-.75a.375.375 0 0 1 .75 0v.75h.75a.375.375 0 0 1 0 .75h-.75v.75a.375.375 0 0 1-.75 0v-.75h-.75a.375.375 0 0 1-.375-.375"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIncrementValue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/increment-value.4abe181c.svg";